import React from 'react';
import { LoadingImg } from './loadingImg';


export function Loading() {
    return (
        <div className="w3-center w3-padding-32">
            <LoadingImg />
            <b className="w3-margin">Loading...</b>
        </div>
    );
}
